import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { IsEnum } from "class-validator";

export class OpInventoryRequest{
    @ApiProperty({
        enum: OperationTypeEnum
    })
    @IsEnum(OperationTypeEnum)
    operation: OperationTypeEnum;


    @ApiProperty()
    plantId: number;
}